module.exports = __webpack_public_path__ + "static/media/Rotessa-loading-fail.d1f05836.png";